import React from "react";

export default class ChangingProgressProvider extends React.Component {
  state = {
    valuesIndex: 0
  };

  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  componentDidMount() {
    document.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(e) {
    const wrappedElement = document.getElementById("progress");

    if (this.isBottom(wrappedElement)) {
      this.setState({
        valuesIndex: (this.state.valuesIndex + 1) % this.props.values.length
      });
      document.removeEventListener("scroll", this.handleScroll);
    }
  }

  render() {
    return this.props.children(this.props.values[this.state.valuesIndex]);
  }
}
